export const JURISDICTIONS = [
  "Delaware", "California", "New York", "Texas", "Florida", "Illinois",
  "Washington", "Nevada", "Colorado", "Georgia", "North Carolina",
  "Virginia", "Massachusetts", "Pennsylvania", "Other"
];

export const INDUSTRY_OPTIONS = [
  { value: 'general', label: 'General Business' },
  { value: 'tech', label: 'Technology & Software' },
  { value: 'creative', label: 'Creative & Design' },
  { value: 'realestate', label: 'Real Estate' },
  { value: 'healthcare', label: 'Healthcare & Life Sciences' },
  { value: 'financial', label: 'Financial Services' }
];
